module.exports = __webpack_public_path__ + "static/img/banner-wrightin.81e6ee1a.png";